
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'deal-plans-ui',
  currentProjectVersion: 'static-1.2229',
  depVersions: {
  "deal-plans-ui": "static-1.2229",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.501",
  "diff": "static-1.7",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26253",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5927",
  "hs-test-utils": "static-1.8370",
  "hub-http-shared-msw-handlers": "static-1.10676",
  "hubspot-dlb": "static-2.1905",
  "HubStyleTokens": "static-2.11829",
  "immutable": "static-2.87",
  "jasmine-runner": "static-1.6787",
  "portals-platform-bend-plugin": "static-1.23",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7504",
  "react-colorpicker": "static-2.10550",
  "react-dlb": "static-1.89",
  "react-utils": "static-2.5580",
  "reselect": "static-3.12",
  "rich-text-lib": "static-1.20352",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18427",
  "ui-components-test-utils": "static-1.5966",
  "avatar-components": "static-1.2819",
  "data-fetching-client": "static-1.9990",
  "deal-plans-lib": "static-1.1510",
  "ui-addon-emoji-picker": "static-1.10221",
  "FileManagerLib": "static-1.40223",
  "foundations-assets": "static-1.5224",
  "foundations-components": "static-1.8543",
  "foundations-theming": "static-1.4813",
  "framer-motion": "static-1.79",
  "hub-http": "static-1.6549",
  "hubspot-prosemirror": "static-1.19044",
  "hubspot-url-utils": "static-1.4366",
  "I18n": "static-7.1679",
  "js-cookie": "static-1.18",
  "payment-link-components": "static-1.24216",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1496",
  "quartz-auth": "static-1.1179",
  "quartz-config": "static-1.1282",
  "quartz-core": "static-1.6723",
  "quartz-routing": "static-1.934",
  "quick-fetch": "static-1.4152",
  "raven": "static-3.5925",
  "react": "static-7.196",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "rpc-client-utils": "static-1.5003",
  "sanitize-text": "static-1.8494",
  "ui-addon-i18n": "static-1.11483",
  "ui-addon-react-router-dom": "static-1.9869",
  "UIComponents": "static-3.8775",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9963",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3781",
  "quartz-webpack": "static-1.3728",
  "bend-plugin-quartz-routing": "static-1.582",
  "customer-data-objects": "static-1.8034",
  "frontend-preferences-client": "static-1.8256",
  "graphql": "static-1.89",
  "laboratory-lib": "static-3.7490",
  "onboarding-scopes": "static-1.6790",
  "seat-types-lib": "static-1.799",
  "ui-addon-opt": "static-4.8703",
  "usage-tracker": "static-1.7650",
  "usage-tracker-core": "static-1.7500",
  "HeadJS": "static-2.803",
  "hs-test-utils-bend-plugin": "static-1.3481",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "ts-schema": "static-1.4318",
  "webpack-env": "static-1.54",
  "jasmine": "static-4.4649",
  "bender-build-tools": "static-1.3452",
  "hs-story-utils": "static-1.9762",
  "StyleGuideUI": "static-3.507",
  "data-token-picker": "static-1.16932",
  "icons": "static-2.693",
  "PatternValidationJS": "static-1.3229",
  "property-translator": "static-1.5731",
  "reference-resolvers-lite": "static-1.8441",
  "cssUtils": "static-1.959",
  "HubStyle": "static-2.12136",
  "merchandise-lib": "static-1.279",
  "purchase-motions-components": "static-1.6422",
  "react-input-autosize": "static-2.17",
  "SharedI18nStrings": "static-1.183",
  "foundations-components-test-utils": "static-1.6026",
  "ui-addon-draggable": "static-3.5093",
  "hub-http-janus": "static-1.887",
  "hubspotter-http": "static-1.4888",
  "fast-json-stable-stringify": "static-1.4",
  "crm-message-bus": "static-1.43837",
  "property-value-citations": "static-1.3303",
  "ui-business-units-lib": "static-1.9428",
  "ai-components-ui-library": "static-1.9790",
  "audio-components": "static-1.6390",
  "file-manager-components": "static-1.24583",
  "FileManagerCore": "static-1.40082",
  "FileManagerImages": "static-1.37734",
  "quartz-i18n": "static-1.1179",
  "react-virtualized": "static-2.107",
  "redux-thunk": "static-2.80",
  "video-components": "static-1.14211",
  "bend-plugin-foundations-components": "static-1.4812",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2529",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.78",
  "react-select-plus": "static-1.113",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2733",
  "ui-fonts": "static-1.1091",
  "ui-images": "static-2.1262",
  "bend-plugin-foundations-theming": "static-1.3296",
  "foundations-theming-base": "static-1.3798",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.319",
  "content-assistance-lib": "static-1.8243",
  "content-media-capture": "static-1.5516",
  "customer-data-ui-utilities": "static-1.10168",
  "knowledge-content-types": "static-1.8682",
  "ui-shepherd-react": "static-3.10607",
  "video-components-external": "static-1.12209",
  "video-data-lib": "static-1.35867",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "commerce-tours-lib": "static-1.6669",
  "customer-data-properties": "static-1.52689",
  "getting-started-shared-tasks": "static-1.19310",
  "growth-onboarding-reliability": "static-1.5417",
  "onboarding-tours": "static-1.17181",
  "sales-checkout-service-client": "static-1.3865",
  "ui-addon-iframeable": "static-1.9414",
  "user-context": "static-1.5458",
  "interframe": "static-3.5092",
  "usage-tracker-multi": "static-1.6064",
  "hubspotter-http-shared-msw-handlers": "static-1.10674",
  "opentelemetry-fe-types": "static-1.113",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.583",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.488",
  "quartz-head": "static-1.1169",
  "quartz-test": "static-1.1179",
  "quartz-tracking": "static-1.883",
  "trellis-components": "static-1.2752",
  "usage-tracker-container": "static-1.7640",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "bend-plugin-chirp-manifest": "static-1.413",
  "chirp-fetch": "static-1.2233",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4809",
  "inbound-db-properties-service-client": "static-1.4072",
  "superstore": "static-1.5096",
  "feedback-loader": "static-1.29856",
  "sassPrefix": "static-1.226",
  "batch-promise": "static-1.1882",
  "external-options-client-types": "static-1.4365",
  "framework-data-schema-resolvers": "static-1.7230",
  "foundations-components-legacy": "static-1.1568",
  "purchase-motions-api": "static-1.6425",
  "signup-constants": "static-1.19683",
  "signup-ui-url-generator": "static-2.8397",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.78",
  "restore-request-side-panel-lib": "static-1.1739",
  "crm-links": "static-1.6658",
  "customer-data-objects-ui-components": "static-1.13368",
  "hs-resources": "static-1.530",
  "inbound-db-meta-service-client": "static-1.3718",
  "pulse": "static-1.967",
  "smart-property-lib": "static-1.8369",
  "atom": "static-1.5419",
  "magpie-lib": "static-1.5782",
  "navigation-messaging": "static-1.8226",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.8518",
  "chatspot-core": "static-1.23183",
  "ContentUtils": "static-1.69196",
  "copilot-toolkit": "static-1.11905",
  "breeze-engine-lib": "static-1.1828",
  "apollo-link-hub-http": "static-2.4994",
  "immer": "static-1.101",
  "immerable": "static-1.4483",
  "breeze-artifacts-sdk": "static-1.454",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "redux-toolkit": "static-1.78",
  "salesImages": "static-1.597",
  "ui-universal-auth": "static-1.9465",
  "urlinator": "static-1.4867",
  "video-embed": "static-1.36701",
  "content-icons-ui": "static-1.2400",
  "social-insights-client-types": "static-1.22706",
  "stylex-utils": "static-1.147",
  "trellis-theming": "static-1.1310",
  "ui-addon-video-player": "static-1.9039",
  "ui-coaching-tips": "static-1.29371",
  "content-media-composition-data-lib": "static-1.13320",
  "fix-webm-duration": "static-1.30",
  "notification-sounds": "static-1.4762",
  "react-dnd-compat": "static-1.4953",
  "react-immutable-render-mixin": "static-1.9",
  "content-media-compositions": "static-2.17327",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5242",
  "media-bridge-lib": "static-1.19450",
  "commerce-products-lib": "static-1.10612",
  "growth-data-modal": "static-1.5940",
  "hubspot-apollo-client": "static-1.5214",
  "onboarding-tours-client": "static-1.5396",
  "calling-global-api": "static-1.65735",
  "calling-internal-common": "static-1.31659",
  "calling-lifecycle-internal": "static-1.67117",
  "calling-lifecycle-messages": "static-1.59411",
  "conditional-properties-service-client": "static-1.4041",
  "crm-index-visualization-core": "static-1.4585",
  "crm-pipelines-api-client-types": "static-1.4372",
  "customer-data-properties-shared-msw-handlers": "static-1.10003",
  "customer-data-property-utils": "static-1.8435",
  "formula-editor": "static-1.14816",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4453",
  "meetings-icalendar-utils-lib": "static-1.972",
  "multi-currency-client-types": "static-1.3932",
  "object-builder-ui-client": "static-1.49758",
  "pipeline-validation-client-types": "static-1.4207",
  "smart-data-capture-core": "static-1.198",
  "tiered-pricing": "static-1.2011",
  "topics-actions-lib": "static-1.507",
  "trial-components-library": "static-1.14164",
  "ui-addon-form-validation": "static-1.11321",
  "zustand": "static-1.85",
  "growth-onboarding-confetti": "static-1.3402",
  "growth-onboarding-next-action-utils": "static-1.2752",
  "navigation-components": "static-1.18899",
  "onboarding-tours-utils": "static-1.1248",
  "ui-shepherd-tracker": "static-1.7988",
  "getting-started-shared-tasks-store": "static-1.18428",
  "usage-tracker-anonymous": "static-1.6067",
  "usage-tracker-public": "static-1.7461",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.41",
  "usage-tracker-session-replay": "static-1.5336",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "fdsr-migration-layer": "static-1.349",
  "framework-builder-read-service-client": "static-1.4246",
  "framework-data-schema-quick-fetch": "static-1.7135",
  "persist-promise": "static-1.4039",
  "location-customization-utils-lib": "static-1.10166",
  "event-emitter": "static-1.1292",
  "bend-plugin-pulse": "static-1.470",
  "fast-json-patch": "static-1.70",
  "data-agent-kit": "static-1.698",
  "markdown-it": "static-1.6",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10759",
  "fsm": "static-1.4090",
  "policy-lib": "static-1.7142",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10822",
  "reactive-lib": "static-1.1056",
  "simple-logging-lib": "static-1.3388",
  "cms-field-types": "static-1.5149",
  "integrations-lib": "static-1.17137",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.806",
  "breeze-engine-core": "static-1.1106",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "unified-auth-core-lib": "static-1.1261",
  "outpost": "static-1.4490",
  "growth-onboarding-feedback-components": "static-1.6922",
  "commerce-permissions": "static-1.1114",
  "customer-data-tracking": "static-1.7219",
  "products-iframe-lib": "static-1.8646",
  "products-ui-components-shared-msw-handlers": "static-1.11058",
  "onboarding-data-sync-lib": "static-1.2562",
  "hubspot-apollo-cache": "static-1.673",
  "calling-error-reporting": "static-1.31666",
  "shared-worker-versioning": "static-1.11378",
  "calling-usage-tracker": "static-1.6873",
  "voice-sms-access-library": "static-1.2131",
  "conversations-skeleton-state": "static-1.7584",
  "crm-index-associations-lib": "static-1.6781",
  "sales-views-client-types": "static-1.4593",
  "bark-lib": "static-1.16852",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6227",
  "react-codemirror": "static-1.10980",
  "embedded-academy-lib": "static-1.15629",
  "hubs-service-types": "static-1.1597",
  "growth-onboarding-next-action-components": "static-1.2780",
  "user-context-client": "static-1.4845",
  "nest": "static-1.574",
  "amplitude-session-replay-browser": "static-1.60",
  "crm-record-cards-service-types": "static-1.3796",
  "highcharts": "static-8.111",
  "trellis-story-utils": "static-1.4844",
  "storybook-react": "static-1.40",
  "flux-actions": "static-1.373",
  "integrations-error-boundary-lib": "static-1.14552",
  "integrations-tracking-lib": "static-1.5945",
  "native-integrations-shared-strings": "static-1.8114",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10707",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.979",
  "InboxConnectUtils": "static-4.15618",
  "meetings-connect-utils-lib": "static-1.7948",
  "calling-orchestration-schema": "static-1.36908",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16426",
  "browser-eslint": "static-2.57",
  "academy-common-lib": "static-1.15089",
  "universal-page-editor-lib": "static-1.3345",
  "adobe-sign-auth-lib": "static-1.531",
  "ads-unified-auth-lib": "static-1.1502",
  "custom-vendor-connection-lib": "static-1.29",
  "google-sheets-integration-lib": "static-1.1093",
  "microsoft-drive-auth-lib": "static-1.209",
  "surveymonkey-integration-lib": "static-1.548",
  "slack-ui-library": "static-1.10736",
  "hub-http-contrib": "static-1.3377",
  "ui-addon-sales-email": "static-1.5551",
  "academy-service-client": "static-1.4029",
  "croppie": "static-2.10",
  "final-form": "static-1.78",
  "SafeStorage": "static-1.4743",
  "trellis-ecosystem": "static-1.7671",
  "wootric-nps": "static-1.7225",
  "marketplace-ui-apps-core": "static-1.19332",
  "marketplace-ui-common": "static-1.20800",
  "developer-experience-shared-components": "static-1.10875",
  "immutable-less": "static-1.4988",
  "marketplace-ui-client-types": "static-1.18207",
  "ui-addon-integrations-directory-panel": "static-2.8364",
  "ui-extensibility-client-types": "static-1.4254",
  "ai-settings-ui-library": "static-1.8388",
  "nav-meta": "static-1.30536",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1165",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4570",
  "settings-ui-lib": "static-1.12861",
  "simple-data-table": "static-1.3577"
},
  depPathPrefixes: {
  "deal-plans-ui": "/deal-plans-ui/static-1.2229",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.501",
  "diff": "/diff/static-1.7",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26253",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5927",
  "hs-test-utils": "/hs-test-utils/static-1.8370",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10676",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "HubStyleTokens": "/HubStyleTokens/static-2.11829",
  "immutable": "/immutable/static-2.87",
  "jasmine-runner": "/jasmine-runner/static-1.6787",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.23",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7504",
  "react-colorpicker": "/react-colorpicker/static-2.10550",
  "react-dlb": "/react-dlb/static-1.89",
  "react-utils": "/react-utils/static-2.5580",
  "reselect": "/reselect/static-3.12",
  "rich-text-lib": "/rich-text-lib/static-1.20352",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18427",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5966",
  "avatar-components": "/avatar-components/static-1.2819",
  "data-fetching-client": "/data-fetching-client/static-1.9990",
  "deal-plans-lib": "/deal-plans-lib/static-1.1510",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10221",
  "FileManagerLib": "/FileManagerLib/static-1.40223",
  "foundations-assets": "/foundations-assets/static-1.5224",
  "foundations-components": "/foundations-components/static-1.8543",
  "foundations-theming": "/foundations-theming/static-1.4813",
  "framer-motion": "/framer-motion/static-1.79",
  "hub-http": "/hub-http/static-1.6549",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19044",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "I18n": "/I18n/static-7.1679",
  "js-cookie": "/js-cookie/static-1.18",
  "payment-link-components": "/payment-link-components/static-1.24216",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1496",
  "quartz-auth": "/quartz-auth/static-1.1179",
  "quartz-config": "/quartz-config/static-1.1282",
  "quartz-core": "/quartz-core/static-1.6723",
  "quartz-routing": "/quartz-routing/static-1.934",
  "quick-fetch": "/quick-fetch/static-1.4152",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.196",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "rpc-client-utils": "/rpc-client-utils/static-1.5003",
  "sanitize-text": "/sanitize-text/static-1.8494",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11483",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9869",
  "UIComponents": "/UIComponents/static-3.8775",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9963",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3781",
  "quartz-webpack": "/quartz-webpack/static-1.3728",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.582",
  "customer-data-objects": "/customer-data-objects/static-1.8034",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8256",
  "graphql": "/graphql/static-1.89",
  "laboratory-lib": "/laboratory-lib/static-3.7490",
  "onboarding-scopes": "/onboarding-scopes/static-1.6790",
  "seat-types-lib": "/seat-types-lib/static-1.799",
  "ui-addon-opt": "/ui-addon-opt/static-4.8703",
  "usage-tracker": "/usage-tracker/static-1.7650",
  "usage-tracker-core": "/usage-tracker-core/static-1.7500",
  "HeadJS": "/HeadJS/static-2.803",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3481",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "ts-schema": "/ts-schema/static-1.4318",
  "webpack-env": "/webpack-env/static-1.54",
  "jasmine": "/jasmine/static-4.4649",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "hs-story-utils": "/hs-story-utils/static-1.9762",
  "StyleGuideUI": "/StyleGuideUI/static-3.507",
  "data-token-picker": "/data-token-picker/static-1.16932",
  "icons": "/icons/static-2.693",
  "PatternValidationJS": "/PatternValidationJS/static-1.3229",
  "property-translator": "/property-translator/static-1.5731",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8441",
  "cssUtils": "/cssUtils/static-1.959",
  "HubStyle": "/HubStyle/static-2.12136",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "purchase-motions-components": "/purchase-motions-components/static-1.6422",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6026",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5093",
  "hub-http-janus": "/hub-http-janus/static-1.887",
  "hubspotter-http": "/hubspotter-http/static-1.4888",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "crm-message-bus": "/crm-message-bus/static-1.43837",
  "property-value-citations": "/property-value-citations/static-1.3303",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9428",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9790",
  "audio-components": "/audio-components/static-1.6390",
  "file-manager-components": "/file-manager-components/static-1.24583",
  "FileManagerCore": "/FileManagerCore/static-1.40082",
  "FileManagerImages": "/FileManagerImages/static-1.37734",
  "quartz-i18n": "/quartz-i18n/static-1.1179",
  "react-virtualized": "/react-virtualized/static-2.107",
  "redux-thunk": "/redux-thunk/static-2.80",
  "video-components": "/video-components/static-1.14211",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4812",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2529",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.78",
  "react-select-plus": "/react-select-plus/static-1.113",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2733",
  "ui-fonts": "/ui-fonts/static-1.1091",
  "ui-images": "/ui-images/static-2.1262",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3296",
  "foundations-theming-base": "/foundations-theming-base/static-1.3798",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.319",
  "content-assistance-lib": "/content-assistance-lib/static-1.8243",
  "content-media-capture": "/content-media-capture/static-1.5516",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10168",
  "knowledge-content-types": "/knowledge-content-types/static-1.8682",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10607",
  "video-components-external": "/video-components-external/static-1.12209",
  "video-data-lib": "/video-data-lib/static-1.35867",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6669",
  "customer-data-properties": "/customer-data-properties/static-1.52689",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19310",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5417",
  "onboarding-tours": "/onboarding-tours/static-1.17181",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3865",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9414",
  "user-context": "/user-context/static-1.5458",
  "interframe": "/interframe/static-3.5092",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6064",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10674",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.113",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.583",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.488",
  "quartz-head": "/quartz-head/static-1.1169",
  "quartz-test": "/quartz-test/static-1.1179",
  "quartz-tracking": "/quartz-tracking/static-1.883",
  "trellis-components": "/trellis-components/static-1.2752",
  "usage-tracker-container": "/usage-tracker-container/static-1.7640",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.413",
  "chirp-fetch": "/chirp-fetch/static-1.2233",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4809",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4072",
  "superstore": "/superstore/static-1.5096",
  "feedback-loader": "/feedback-loader/static-1.29856",
  "sassPrefix": "/sassPrefix/static-1.226",
  "batch-promise": "/batch-promise/static-1.1882",
  "external-options-client-types": "/external-options-client-types/static-1.4365",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7230",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1568",
  "purchase-motions-api": "/purchase-motions-api/static-1.6425",
  "signup-constants": "/signup-constants/static-1.19683",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8397",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.78",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1739",
  "crm-links": "/crm-links/static-1.6658",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13368",
  "hs-resources": "/hs-resources/static-1.530",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "pulse": "/pulse/static-1.967",
  "smart-property-lib": "/smart-property-lib/static-1.8369",
  "atom": "/atom/static-1.5419",
  "magpie-lib": "/magpie-lib/static-1.5782",
  "navigation-messaging": "/navigation-messaging/static-1.8226",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.8518",
  "chatspot-core": "/chatspot-core/static-1.23183",
  "ContentUtils": "/ContentUtils/static-1.69196",
  "copilot-toolkit": "/copilot-toolkit/static-1.11905",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1828",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4994",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4483",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.454",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "salesImages": "/salesImages/static-1.597",
  "ui-universal-auth": "/ui-universal-auth/static-1.9465",
  "urlinator": "/urlinator/static-1.4867",
  "video-embed": "/video-embed/static-1.36701",
  "content-icons-ui": "/content-icons-ui/static-1.2400",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "stylex-utils": "/stylex-utils/static-1.147",
  "trellis-theming": "/trellis-theming/static-1.1310",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9039",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29371",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13320",
  "fix-webm-duration": "/fix-webm-duration/static-1.30",
  "notification-sounds": "/notification-sounds/static-1.4762",
  "react-dnd-compat": "/react-dnd-compat/static-1.4953",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "content-media-compositions": "/content-media-compositions/static-2.17327",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5242",
  "media-bridge-lib": "/media-bridge-lib/static-1.19450",
  "commerce-products-lib": "/commerce-products-lib/static-1.10612",
  "growth-data-modal": "/growth-data-modal/static-1.5940",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5214",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5396",
  "calling-global-api": "/calling-global-api/static-1.65735",
  "calling-internal-common": "/calling-internal-common/static-1.31659",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67117",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59411",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4041",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4585",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4372",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10003",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8435",
  "formula-editor": "/formula-editor/static-1.14816",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4453",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.972",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3932",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49758",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4207",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.198",
  "tiered-pricing": "/tiered-pricing/static-1.2011",
  "topics-actions-lib": "/topics-actions-lib/static-1.507",
  "trial-components-library": "/trial-components-library/static-1.14164",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11321",
  "zustand": "/zustand/static-1.85",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3402",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2752",
  "navigation-components": "/navigation-components/static-1.18899",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1248",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7988",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18428",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6067",
  "usage-tracker-public": "/usage-tracker-public/static-1.7461",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.41",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5336",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.349",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4246",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7135",
  "persist-promise": "/persist-promise/static-1.4039",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10166",
  "event-emitter": "/event-emitter/static-1.1292",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.470",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "data-agent-kit": "/data-agent-kit/static-1.698",
  "markdown-it": "/markdown-it/static-1.6",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10759",
  "fsm": "/fsm/static-1.4090",
  "policy-lib": "/policy-lib/static-1.7142",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10822",
  "reactive-lib": "/reactive-lib/static-1.1056",
  "simple-logging-lib": "/simple-logging-lib/static-1.3388",
  "cms-field-types": "/cms-field-types/static-1.5149",
  "integrations-lib": "/integrations-lib/static-1.17137",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.806",
  "breeze-engine-core": "/breeze-engine-core/static-1.1106",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1261",
  "outpost": "/outpost/static-1.4490",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6922",
  "commerce-permissions": "/commerce-permissions/static-1.1114",
  "customer-data-tracking": "/customer-data-tracking/static-1.7219",
  "products-iframe-lib": "/products-iframe-lib/static-1.8646",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11058",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2562",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.673",
  "calling-error-reporting": "/calling-error-reporting/static-1.31666",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11378",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6873",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2131",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7584",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6781",
  "sales-views-client-types": "/sales-views-client-types/static-1.4593",
  "bark-lib": "/bark-lib/static-1.16852",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6227",
  "react-codemirror": "/react-codemirror/static-1.10980",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15629",
  "hubs-service-types": "/hubs-service-types/static-1.1597",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2780",
  "user-context-client": "/user-context-client/static-1.4845",
  "nest": "/nest/static-1.574",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "highcharts": "/highcharts/static-8.111",
  "trellis-story-utils": "/trellis-story-utils/static-1.4844",
  "storybook-react": "/storybook-react/static-1.40",
  "flux-actions": "/flux-actions/static-1.373",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14552",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5945",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8114",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10707",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.979",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15618",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7948",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36908",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16426",
  "browser-eslint": "/browser-eslint/static-2.57",
  "academy-common-lib": "/academy-common-lib/static-1.15089",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3345",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.531",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1502",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.29",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1093",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.209",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.548",
  "slack-ui-library": "/slack-ui-library/static-1.10736",
  "hub-http-contrib": "/hub-http-contrib/static-1.3377",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5551",
  "academy-service-client": "/academy-service-client/static-1.4029",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.78",
  "SafeStorage": "/SafeStorage/static-1.4743",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7671",
  "wootric-nps": "/wootric-nps/static-1.7225",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19332",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20800",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10875",
  "immutable-less": "/immutable-less/static-1.4988",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18207",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8364",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4254",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8388",
  "nav-meta": "/nav-meta/static-1.30536",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1165",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4570",
  "settings-ui-lib": "/settings-ui-lib/static-1.12861",
  "simple-data-table": "/simple-data-table/static-1.3577"
}
};
